import {ChangeDetectorRef, Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {MatDialog, Sort} from "@angular/material";
import { HotspotDot } from "../../../model/HotspotDot";
import {TranslateService} from "@ngx-translate/core";
import {ActivatedRoute, Router} from "@angular/router";
import {HotspotCreatorService} from "../../../service/http/hotspot-creator.service";
import {catchError, map, startWith, switchMap} from "rxjs/operators";
import {Observable, Observer, of as observableOf} from "rxjs";
import {AcceptDeclineDialogComponent} from "../../../dialog/accept-decline-dialog/accept-decline-dialog.component";
import {AddHotspotDotDialogComponent} from "./add-hotspot-dot-dialog/add-hotspot-dot-dialog.component";
import {UpdateHotspotDotDialogComponent} from "./update-hotspot-dot-dialog/update-hotspot-dot-dialog.component";
import {environment} from "../../../../environments/environment";
import {MessageDialogComponent} from "../../../dialog/message-dialog/message-dialog.component";
import {HttpClient} from "@angular/common/http";

@Component({
  selector: 'app-workflow-hotspot-dot-setter',
  templateUrl: './workflow-hotspot-dot-setter.component.html',
  styleUrls: ['./workflow-hotspot-dot-setter.component.css']
})
export class WorkflowHotspotDotSetterComponent implements OnInit {

  displayedColumns: string[] = ['id', 'label', 'link-ref', 'x-pos', 'y-pos', 'actions'];
  data: HotspotDot[] = [];
  isLoadingResults = false;
  currentPackageIdGlobal: any;
  hotspotId: number;
  selectedHotspotDotId: number;
  node: string;
  dots: Array<number> = new Array();
  imageUrl = 'assets/hotspot/IPIC_SAMPLE.jpg';
  urlImageUpload = '';
  isLoadingImage = true;
  dataImage: any = [];
  realImageWidth: number = 700;
  realImageHeight: number = 600;

  @ViewChild('hotspotImage') hotspotImageRef: ElementRef;
  @ViewChild('imageUpload') imageUpload;

  constructor(private hotspotCreatorService: HotspotCreatorService,
              private translate: TranslateService,
              private _router: Router,
              private route: ActivatedRoute,
              public dialog: MatDialog,
              private elementRef: ElementRef,
              private http: HttpClient,
              private cdRef: ChangeDetectorRef) { }

  ngOnInit() {

    let currentPackageId = sessionStorage.getItem('currentPackageId');
    if(currentPackageId !== null) {
      this.currentPackageIdGlobal = currentPackageId;
    }

    this.route.params.subscribe(params => {
      this.hotspotId = +params['id'];
    });

    this.loadTableData();
    this.urlImageUpload = `${environment.packagesManagerBackendUrl}` + '/hotspot-creator/hotspot/add-image/' + this.currentPackageIdGlobal + '/' + this.hotspotId;

    let error = false;
    this.http.get(`${environment.packagesManagerBackendUrl}` + '/hotspot-creator/download/hotspot-image/' + this.currentPackageIdGlobal + '/' + this.hotspotId,
      { responseType: 'blob' }).pipe(
        catchError(() => {
          this.isLoadingImage = false;
          error = true;
          return observableOf([]);
        })
      ).subscribe(data => {
        if(!error) {
          this.imageUrl = `${environment.packagesManagerBackendUrl}` + '/hotspot-creator/download/hotspot-image/' + this.currentPackageIdGlobal + '/' + this.hotspotId
            + "?" + Math.random()* 100000000000000000000;
          this.cdRef.detectChanges();

          this.http.get(`${environment.packagesManagerBackendUrl}` + '/hotspot-creator/download/hotspot-image-json/' + this.currentPackageIdGlobal + '/' + this.hotspotId)
            .subscribe(data => {
              this.realImageWidth = data["width"];
              this.realImageHeight = data["height"];
              this.loadTableData();
              this.isLoadingImage = false;
            });
        }
    });
  }

  loadTableData() {

    this.hotspotCreatorService.getHotspotDot(this.currentPackageIdGlobal, this.hotspotId).pipe(
      startWith([]),
      switchMap(() => {
        this.isLoadingResults = true;
        return this.hotspotCreatorService.getHotspotDot(this.currentPackageIdGlobal, this.hotspotId);
      }),
      map(data => {
        this.isLoadingResults = false;
        return data;
      }),
      catchError(() => {
        this.isLoadingResults = false;
        return observableOf([]);
      })
    ).subscribe(data => {
      this.data = data;
      this.refreshDots();
      setTimeout(()=>{ this.addRedCircles(); }, 100);
    });

  }

  refreshDots() {
    this.dots = [];
    for(let i=0; i < this.data.length; i++) {
      this.dots.push(this.data[i].id);
    }
  }

  addRedCircles() {

    let imageWidth = this.hotspotImageRef.nativeElement.getBoundingClientRect().width;
    let imageHeight = this.hotspotImageRef.nativeElement.getBoundingClientRect().height;

    for(let i=0; i < this.data.length; i++) {

      this.calcXforHotspotImage(this.data[i].x, imageWidth);
      this.calcYforHotspotImage(this.data[i].x, imageHeight);

      let dotPosX = this.calcXforBrowserImage(this.data[i].x, imageWidth);
      let dotPosY = this.calcYforBrowserImage(this.data[i].y, imageHeight);
      document.getElementById('dot' + i).setAttribute('style',
        'top:' + ((dotPosY) +  - 15) + 'px; ' + 'left:' + ((dotPosX) +  - 15) + 'px;');
    }
  }

  addDot() {
      let dialogRef = this.dialog.open(AddHotspotDotDialogComponent, {
      width: '30%',
      height: '40%',
      data: { hotspotId: this.hotspotId }
    });

    dialogRef.afterClosed().subscribe(result => {
      this.loadTableData();
    });
  }

  editDot(dotId: number, dotTabelIndex: number) {

    let dialogRef = this.dialog.open(UpdateHotspotDotDialogComponent, {
      width: '30%',
      height: '45%',
      data: { hotspotId: this.hotspotId,
              updateDotId: dotId,
              hotspotDot: this.data[dotTabelIndex]
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      // console.log('linkRef: ' + result.linkRef);
      this.loadTableData();
    });

  }

  deleteDot(dotId: number) {

    const dialogRef = this.dialog.open(AcceptDeclineDialogComponent, {
      width: '250px',
      data: {
        title: this.translate.instant('DIALOG.ACCEPT_DECLINE_DIALOG.TITLE'),
        message: this.translate.instant('Do you really want to delete the hotspot dot?'),
        icon: {
          add: false,
          name: ''
        }
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if(result == true) {
        this.hotspotCreatorService.deleteHotspotDot(this.currentPackageIdGlobal, this.hotspotId, dotId).subscribe(data => {
          this.loadTableData();
        });
      }
    });
  }

  selectedRow(row){
    this.selectedHotspotDotId = row.id;
  }

  setDot(event: MouseEvent) {

    if(this.selectedHotspotDotId != null) {

      let imageWidth = this.hotspotImageRef.nativeElement.getBoundingClientRect().width;
      let imageHeight = this.hotspotImageRef.nativeElement.getBoundingClientRect().height;

      this.data.find(value => value.id == this.selectedHotspotDotId).x = this.calcXforHotspotImage(event.offsetX, imageWidth);
      this.data.find(value => value.id == this.selectedHotspotDotId).y = this.calcYforHotspotImage(event.offsetY, imageHeight);

      this.refreshDots();
      setTimeout(()=>{ this.addRedCircles(); }, 100);

      let selectedHotspotDot: HotspotDot = this.data.find(value => value.id == this.selectedHotspotDotId);
      this.hotspotCreatorService.updateHotspotDot(this.currentPackageIdGlobal, this.hotspotId, this.selectedHotspotDotId,
        {
          'dot-label': selectedHotspotDot.label,
          "link-ref": selectedHotspotDot.linkRef,
          "link-base-id": selectedHotspotDot.linkBaseId,
          "link-target": selectedHotspotDot.linkTarget,
          "x": selectedHotspotDot.x.toString(),
          "y": selectedHotspotDot.y.toString()})
        .subscribe();
    }

  }

  calcXforHotspotImage(xPos: number, browserWidth: number): number {
    let realImageWidth = this.realImageWidth;

    let result = '' + ((xPos/browserWidth) * realImageWidth);
    result = parseFloat(result).toFixed(3);
    return parseFloat(result);
  }

  calcYforHotspotImage(yPos: number, browserHeight: number): number {
    let realImageHeight = this.realImageHeight;

    let result = '' + ((yPos/browserHeight) * realImageHeight);
    result = parseFloat(result).toFixed(3);
    return parseFloat(result);
  }

  calcXforBrowserImage(xPos: number, browserWidth: number): number {
    // let realImageWidth = 750;
    let realImageWidth = this.realImageWidth;

    let result = '' + ((xPos/realImageWidth) * browserWidth);
    result = parseFloat(result).toFixed(3);
    return parseFloat(result);
  }

  calcYforBrowserImage(yPos: number, browserHeight: number): number {
    // let realImageHeight = 600;
    let realImageHeight = this.realImageHeight;

    let result = '' + ((yPos/realImageHeight) * browserHeight);
    result = parseFloat(result).toFixed(3);
    return parseFloat(result);
  }

  addImage() {
    this.imageUpload.nativeElement.click();
  }

  onImageAdded() {

    let file = this.imageUpload.nativeElement.files[0];
    let ext = file.name.split(".").pop();

    if(ext == 'jpg') {

          const formData: FormData = new FormData();
          formData.append('file', file, file.name);

          this.isLoadingImage = true;

          this.http.post(this.urlImageUpload, formData).subscribe(data => {
            this.dataImage = data;
            this.imageUrl = `${environment.packagesManagerBackendUrl}` + '/hotspot-creator/download/hotspot-image/' + this.currentPackageIdGlobal + '/' + this.hotspotId
              + "?" + Math.random()* 100000000000000000000;
            this.cdRef.detectChanges();
            this.http.get(`${environment.packagesManagerBackendUrl}` + '/hotspot-creator/download/hotspot-image-json/' + this.currentPackageIdGlobal + '/' + this.hotspotId)
              .subscribe(data => {
                this.isLoadingImage = false;
                this.realImageWidth = data["width"];
                this.realImageHeight = data["height"];
              });
          });

    } else {
      this.openAlarm(ext, 'Wrong File Format!', 'Please provide an image file:', 'identified ');
    }
  }

  openAlarm(type: string, title: string, message: string, secondMsg: string) {

    this.dialog.open(MessageDialogComponent, {
      data: {
        type: type,
        title: this.translate.instant('DIALOG.NO_XML_CHOOSEN_DIALOG.TITLE'),
        message: this.translate.instant('DIALOG.NO_XML_CHOOSEN_DIALOG.MESSAGE'),
        secondMsg: this.translate.instant('DIALOG.NO_XML_CHOOSEN_DIALOG.SECOND_MESSAGE')
      }
    });
  }

  sortData(sort: Sort) {
    const data = this.data.slice();
    if (!sort.active || sort.direction === '') {
      this.data = data;
      return;
    }

    this.data = data.sort((a, b) => {
      const isAsc = sort.direction === 'asc';
      switch (sort.active) {
        case 'id': return this.compare(a.id, b.id, isAsc);
        case 'label': return this.compare(a.label, b.label, isAsc);

        default: return 0;
      }
    });
  }

  compare(a: number | string, b: number | string, isAsc: boolean) {
    return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
  }

}
